import AdministrationFactoryRepositoryImpl from './impl/AdministrationRepositoryImpl'

export default {
  getInstance () {
    return new AdministrationFactoryRepositoryImpl()
  }
}
